{
  "Kullanıcılar": "Gebruikers",
  "kullanicilar": {
    "Admin Olanlar": "Admins",
    "Admin Olmayanlar": "Geen Admins",
    "Bilgisayardan Yükle": "Uploaden vanaf computer",
    "Evet, değiştir": "Ja, wijzigen.",
    "Fotoğrafı Düzenle": "Foto bewerken",
    "Group Yetki": "Groepsrechten",
    "Güvenlik": "Beveiliging",
    "Henüz fotoğraf seçilmedi veya çekilmedi": "Nog geen foto geselecteerd of gemaakt.",
    "Kullanıcı Profil": "Gebruikersprofiel",
    "Kullanıcılar": "Gebruikers",
    "Resmi sürükleyerek konumlandırabilirsiniz": "U kunt de afbeelding slepen om te positioneren.",
    "Sağa Döndür": "Rechtsom draaien",
    "Sola Döndür": "Linksom draaien",
    "Yeni Group Yetki": "Nieuwe Groepsrechten",
    "Yetki": "Toestemming",
    "Yetkileri": "Rechten",
    "veya Webcam Kullan": "of Webcam gebruiken",
    "Çek": "Foto maken",
    "Önizleme": "Voorbeeld",
    "İsim": "Naam",
    "Şifre Değişikliği Yapılıyor?": "Wordt het wachtwoord gewijzigd?",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Durum": "Status",
    "Yenile": "Vernieuwen",
    "E-mail": "Email",
    "Admin": "Admin",
    "Yeni Kullanıcı": "Nieuwe Gebruiker",
    "Kayıt": "Registreren",
    "Güncelle": "Bijwerken",
    "Sil": "Verwijderen",
    "Şifreyi Güncelle": "Wachtwoord Bijwerken",
    "Ad Soyad": "Volledige Naam",
    "E-posta Şifresi Değiştir": "E-mailwachtwoord Wijzigen",
    "Yeni E-posta Şifresi": "Nieuw E-mailwachtwoord",
    "Email": "Email",
    "Grafikler": "Grafieken",
    "Onaylı": "Goedgekeurd",
    "Onaysız": "Niet goedgekeurd",
    "Toplam": "Totaal",
    "Hedef": "Doel",
    "Yapılan": "Voltooid",
    "Randevu": "Afspraak",
    "Referans": "Referentie",
    "Satış": "Verkoop",
    "Sira": "Bestelling",
    "Kod": "Code",
    "Baslik": "Titel",
    "UstKod": "Oudercode",
    "GrupBaslik": "Groepstitel",
    "YetkiListesi": "Autoriteitenlijst",
    "DataYenile": "Vernieuwen",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Aksiyonlar": "Acties",
    "YetkiDuzenle": "Autoriteit Bewerken",
    "YetkiEkle": "Autoriteit Toevoegen",
    "Iptal": "Annuleren",
    "Kaydet": "Opslaan",
    "SilmeOnayi": "Verwijderbevestiging",
    "YetkiSilmeMesaji": "Weet u zeker dat u autoriteit {name} wilt verwijderen?",
    "Hayir": "Nee",
    "Evet": "Ja",
    "Aciklama": "Beschrijving",
    "Mesai": "Overuren"
  }
}
